import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function connectionsList(uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/contacts`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function addConnection(uid, params) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/shops/${uid}/contacts`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
        return err;
      })
  );
}

async function editConnection(uid, id, params) {
  return Promise.resolve().then((v) =>
    axios
      .put(`${config.baseUrl}v1/shops/${uid}/contacts/${id}`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function connectionDetail(uid, id) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/contacts/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function connectionTypes() {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/contents/contact-types`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function deleteConnection(uid, id) {
  return Promise.resolve().then((v) =>
    axios
      .delete(`${config.baseUrl}v1/shops/${uid}/contacts/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export {
  connectionsList,
  addConnection,
  connectionDetail,
  editConnection,
  connectionTypes,
  deleteConnection,
};
